import { ComingSoon } from '@/features/app-shell';
import { t } from '@/lib/i18n';

export default function UsersRoute() {
  return (
    <ComingSoon
      name={t('Users')}
      icon="👤"
      description={t(
        'Invite human collaborators and manage their access levels. Email invitations land with the auth invitation flow (BA-020).',
      )}
    />
  );
}
